// Keeps the header cart count in sync for add-to-cart paths that bypass Dawn's product-form.js.
// The Glow shoppable-video widget POSTs /cart/add.js directly from its own markup, so
// CartDrawer.renderContents never runs and #cart-icon-bubble is left showing a stale count.
// Re-rendering the cart-icon-bubble section keeps Dawn's own empty/non-empty markup authoritative.
(function () {
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var pending = null;

  function refreshCartCount() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + '?section_id=cart-icon-bubble')
        .then(function (response) {
          if (!response.ok) throw new Error('cart-icon-bubble ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var source = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          var target = document.getElementById('cart-icon-bubble');
          if (source && target) target.innerHTML = source.innerHTML;
        })
        .catch(function () {
          // A failed refresh must never break the add itself — the count self-corrects on reload.
        });
    }, 250);
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var url = (arguments[0] && arguments[0].url) || String(arguments[0]);
    return originalFetch.apply(this, arguments).then(function (response) {
      if (response.ok && CART_MUTATION.test(url)) refreshCartCount();
      return response;
    });
  };

  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener('load', function () {
      if (this.status >= 200 && this.status < 300 && CART_MUTATION.test(String(url))) refreshCartCount();
    });
    return originalOpen.apply(this, arguments);
  };
})();
